<template>
	<el-drawer :visible.sync="dialogVisible" title="新建招商活动" size="760px" :wrapperClosable="false" :before-close="handleClose">
		<div class="drawer">
			<div class="drawer-wrap">
				<el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" hide-required-asterisk>
					<div class="card">
						<div class="label">基本信息</div>
						<el-form-item label="活动名称" prop="activity_name">
							<el-input v-model="form.activity_name" placeholder="活动标题对达人可见，请谨慎填写" maxlength="60" show-word-limit />
						</el-form-item>
						<el-form-item prop="activity_start_time">
							<template v-slot:label>
								<div class="flex flex-just-end">
									<span>报名起止时间</span>
									<explain content="活动时间范围1~90天" class="mr-4"></explain>
								</div>
							</template>
							<el-date-picker
								v-model="createTime"
								type="daterange"
								@change="changTime"
								value-format="yyyy-MM-dd"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								:picker-options="pickerOptions"
							/>
							<span class="fz-13 yx-color-text-regular ml-8">活动时间范围1~730天</span>
						</el-form-item>
						<el-form-item label="活动类型" prop="activity_type">
							<el-radio-group v-model="form.activity_type" @change="activityTypeChnage">
								<el-radio :label="1" border class="mr-4">普通招商</el-radio>
								<el-radio :label="2" border class="mr-4">专属招商</el-radio>
								<el-radio :label="3" border class="mr-4">合作招商</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>
					<div class="card" v-if="form.activity_type === 2">
						<div class="label">专属达人</div>
						<el-form-item prop="anchor_ids">
							<template v-slot:label>
								<div class="flex flex-just-end">
									<span>达人账号</span>
									<explain content="仅支持搜索已添加到团队内的达人"></explain>
								</div>
							</template>
							<dr-search-select v-model="form.anchor_ids" :searchTypeArr="searchTypeArr" />
							<span class="fz-12 yx-color-text-regular ml-10">未找到达人？请联系达人商务添加达人</span>
						</el-form-item>
					</div>
					<div class="card" v-if="form.activity_type === 2">
						<div class="label">该专属活动是否支持其余团长报名</div>
						<el-form-item prop="preExclusiveActivitySignType">
							<template v-slot:label>
								<span>支持类型</span>
							</template>
							<el-radio-group v-model="form.preExclusiveActivitySignType" @change="preExclusiveActivitySignTypeChange">
								<el-radio :label="1" border class="mr-4">不支持其余团长报名</el-radio>
								<el-radio :label="2" border class="mr-4">
									所有团长可报名
									<explain content="不同专属招商活动指定的达人id完全一致方可互相报名，故该活动达人所有团长可见。"></explain>
								</el-radio>
								<el-radio :label="3" border class="mr-4">
									指定团长可报名
									<explain content="指定的团长可见，可报名"></explain>
								</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item prop="preActivityUser" v-if="form.preExclusiveActivitySignType == 3">
							<template v-slot:label>
								<div class="flex flex-just-end">
									<span>指定团长</span>
									<explain content="仅支持搜索已添加到合作团长中的团长"></explain>
								</div>
							</template>
							<institutionSearchSelect
								v-model="form.preActivityUser"
								:searchTypeArr="searchTypeInstitutionArr"
								:platformId="PLATFORM_KS.value"
								valueKey="authority_id"
							/>
							<span class="fz-12 yx-color-text-regular ml-10">未找到团长？请在合作团长中添加团长</span>
						</el-form-item>
					</div>
					<div class="card">
						<div class="flex">
							<div class="label">营销信息</div>
							<div class="fz-13 yx-color-text-regular ml-12 mb-20">指定类目后，商家仅可提报选中类目的商品。</div>
						</div>

						<el-form-item>
							<template v-slot:label>
								<div class="flex flex-just-end">
									<span>选择类目</span>
									<explain
										content="1、根据平台要求，话费类目和虚拟券包类目禁入快分销 2、特殊类目暂时无法设置分销计划，可点击“特殊类目”申请销售查看规则"
										class="mr-4"
									></explain>
								</div>
							</template>
							<el-radio-group v-model="cateRadio" @change="changeCate">
								<el-radio v-model="cateRadio" :label="10" border class="mr-4">全部类目</el-radio>
								<el-radio v-if="![3].includes(form.activity_type)" v-model="cateRadio" :label="2" border class="mr-4">部分类目</el-radio>
							</el-radio-group>
						</el-form-item>
						<template v-if="cateRadio === 2">
							<el-form-item>
								<template v-slot:label>
									<div class="flex flex-just-end">
										<span>指定商品类目</span>
									</div>
								</template>
								<el-cascader
									class="cascader"
									:key="cascaderKey"
									v-model="cascader"
									:options="categoryList"
									clearable
									filterable
									:props="props"
									collapse-tags
									@change="cascaderChange"
								/>
							</el-form-item>
							<div class="fz-14 yx-color-text-primary mt-24">已经选中类目设置佣金：</div>
							<div class="handler-table mt-16">
								<div class="header">
									<div>行业类目</div>
									<div>最低佣金要求</div>
								</div>
								<el-table
									:show-header="false"
									:max-height="300"
									:data="form.cate_commission_list"
									current-row-key="cate_id"
									header-row-class-name="table-header-row"
									row-class-name="table-row"
								>
									<el-table-column prop="category_name" label="行业类目" show-overflow-tooltip min-width="100"></el-table-column>
									<el-table-column label="最低佣金要求" width="210">
										<template v-slot="{ row, $index }">
											<el-input-number
												v-model="row.commission_rate"
												controls-position="right"
												:min="0"
												:max="90"
												@change="validateServiceRate"
												@input="tableCommissionRateBlur(row.commission_rate, $index)"
											/>
											<span class="yx-color-text-primary ml-8">%</span>
										</template>
									</el-table-column>
								</el-table>
								<div class="footer">
									<span class="fz-14 yx-color-text-primary mr-12">批量设置佣金</span>
									<el-input-number v-model="batchCommissionRate" controls-position="right" :min="0" :max="90" @input="batchCommissionRateBlur" />
									<span class="yx-color-text-primary ml-8 mr-24">%</span>
									<el-button type="primary" @click="setBatchCommissionRate">应用</el-button>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="footer ml-26">
								<span class="fz-14 yx-color-text-primary mr-12">最低佣金要求</span>
								<el-input-number v-model="batchCommissionRate" controls-position="right" :min="0" :max="90" @input="allCommissionRateBlur" />
								<span class="yx-color-text-primary ml-8 mr-24">%</span>
							</div>
						</template>
						<el-form-item class="mt-30 service" prop="service_rate" label="服务费率">
							<el-radio :label="1" v-model="serviceRateRadio" @change="validateServiceRate">不低于</el-radio>
							<el-input-number class="ml-12" v-model="form.service_rate" @input="serviceRateBlur" controls-position="right" :min="0" :max="90" />
							<span class="yx-color-text-primary ml-8 mr-24">%</span>
							<el-radio :label="0" v-model="serviceRateRadio" @change="validateServiceRate">无</el-radio>
						</el-form-item>
						<div class="mt-24 fz-13 yx-color-text-regular mb-24" style="line-height: 18px">
							此处为报名活动的商品被推广后团长可得到的服务费比例，选择“无”即为发布无服务费的活动，选择“不低于”即为发布有服务费的活动（服务费率需大于0，同时服务费率+佣金率&lt;90%）
						</div>
					</div>
				</el-form>
			</div>
			<div class="bottom-btn">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">完 成</el-button>
			</div>
		</div>
	</el-drawer>
</template>

<script>
import throttle from 'lodash/throttle';
import { PLATFORM_KS } from '@/utils/dataMap';
import { getActivityCategoryList, createKsActivity } from '@/api/secondColonelManage';
import explain from '@/components/common/explain';
import drSearchSelect from '@/components/drSearchSelect';
import institutionSearchSelect from '@/components/business/institutionSearchSelect';
import { addDays, startOfDay, endOfDay } from 'date-fns';

export default {
	name: 'newKsActivityDrawer',
	components: {
		explain,
		drSearchSelect,
		institutionSearchSelect,
	},
	data() {
		const serviceRateValidator = (rule, value, callback) => {
			const {
				serviceRateRadio,
				form: { cate_commission_list },
			} = this;
			if (!serviceRateRadio) return callback();
			const validator = cate_commission_list.every(item => item.commission_rate + value <= 90);
			validator ? callback() : callback(new Error('佣金率+服务费率>90%，请重新填写'));
		};
		return {
			PLATFORM_KS,
			dialogVisible: false,
			cascader: [],
			pickerOptions: {
				disabledDate(time) {
					const endDay = new Date();
					return time.getTime() < startOfDay(endDay) || time.getTime() > endOfDay(addDays(endDay, 730)).getTime();
				},
			},
			form: {
				activity_name: '',
				activity_start_time: '',
				activity_end_time: '',
				activity_type: 1,
				anchor_ids: [],
				preExclusiveActivitySignType: '', //支持类型
				preActivityUser: [], //团长id
				cate_commission_list: [],
				service_rate: 1,
				commission_rate: '',
			},
			rules: {
				activity_name: { required: true, message: '请输入活动名称', trigger: 'blur' },
				activity_start_time: { required: true, message: '请选择报名起止时间', trigger: 'change' },
				activity_type: { required: true, message: '请选择活动类型', trigger: 'change' },
				anchor_ids: { required: true, message: '请选择专属达人', trigger: 'change' },
				preActivityUser: { required: true, message: '请选择指定团长', trigger: 'change' },
				cate_commission_list: { required: true, message: '请选择指定商品类目', trigger: 'change' },
				service_rate: { validator: serviceRateValidator, trigger: 'blur' },
			},
			createTime: [],
			categoryList: [],
			props: {
				multiple: true,
				label: 'category_name',
				children: 'child_category',
			},
			batchCommissionRate: 1,
			serviceRateRadio: 0,
			cascaderKey: 0,
			searchTypeArr: [
				{ label: '昵称', value: '1' },
				{ label: '快手号/ID', value: '2' },
			],
			cateRadio: 10,
			authorityId: '',
			searchTypeInstitutionArr: [
				{ label: '昵称', value: 'institutionName' },
				{ label: 'ID', value: 'number' },
			],
		};
	},
	methods: {
		show(id) {
			this.getActivityCategoryList();
			this.dialogVisible = true;
			this.authorityId = id;
		},
		handleClose() {
			this.form = {
				activity_name: '',
				activity_start_time: '',
				activity_end_time: '',
				activity_type: 1,
				anchor_ids: [],
				preExclusiveActivitySignType: '',
				preActivityUser: [],
				cate_commission_list: [],
				service_rate: 1,
				commission_rate: '',
			};
			this.cascader = [];
			this.createTime = [];
			this.categoryList = [];
			this.batchCommissionRate = 1;
			this.serviceRateRadio = 0;
			this.cascaderKey++;
			this.$refs.ruleForm?.resetFields();
			this.dialogVisible = false;
		},
		async getActivityCategoryList() {
			let { code, data = [] } = await getActivityCategoryList({ platform_id: PLATFORM_KS.value });
			if (code !== 0) return;
			//过滤掉只有一级的数据
			data = data.filter(item => {
				return item.child_category && item.child_category.length > 0;
			});
			this.categoryList = this.getTreeData(data);
		},
		getTreeData(data, name = '') {
			for (let i = 0, len = data.length; i < len; i++) {
				const item = data[i];
				let { category_id: cate_id, category_name } = item;
				category_name = `${name && name + '>'}${category_name}`;
				item.value = {
					cate_id,
					category_name,
					commission_rate: 1,
				};
				item.child_category.length && item.child_category.length > 0
					? this.getTreeData(item.child_category, category_name)
					: Reflect.deleteProperty(item, 'child_category');
			}
			return data;
		},
		batchCommissionRateBlur() {
			this.batchCommissionRate = this.batchCommissionRate === undefined ? 1 : this.batchCommissionRate;
		},
		allCommissionRateBlur() {
			this.batchCommissionRate = this.batchCommissionRate === undefined ? 1 : this.batchCommissionRate;
			this.form.commission_rate = this.batchCommissionRate;
		},
		tableCommissionRateBlur(value = 1, index) {
			this.form.cate_commission_list[index].commission_rate = value;
		},
		validateServiceRate() {
			this.$refs.ruleForm.validateField('service_rate');
		},
		serviceRateBlur() {
			this.form.service_rate = this.form.service_rate === undefined ? 1 : this.form.service_rate;
		},
		cascaderChange(value) {
			this.form.cate_commission_list = value.map(item => item[item.length - 1]);
		},
		changTime(times) {
			[this.form.activity_start_time, this.form.activity_end_time] = times || ['', ''];
		},
		activityTypeChnage() {
			this.form.anchor_ids = [];

			if (this.form.activity_type === 2) {
				this.form.preExclusiveActivitySignType = 1;
			} else {
				this.form.preExclusiveActivitySignType = '';
			}
			if (this.form.activity_type == 3) {
				//活动类型为合作招商
				this.cateRadio = 10;
			}

			this.$refs.ruleForm.clearValidate('anchor_ids');
		},
		setBatchCommissionRate() {
			const { batchCommissionRate } = this;
			this.form.cate_commission_list.forEach(item => (item.commission_rate = batchCommissionRate));

			this.validateServiceRate();
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form, serviceRateRadio, cateRadio: rule_type, authorityId: authority_id } = this;
				let { anchor_ids, preExclusiveActivitySignType, preActivityUser, cate_commission_list, service_rate, commission_rate } = form;
				anchor_ids = anchor_ids.join();
				preActivityUser = preActivityUser.join(); //指定团长id
				cate_commission_list = cate_commission_list.map(({ cate_id, commission_rate }) => ({ cate_id, commission_rate }));
				if (!serviceRateRadio) service_rate = 0;
				const { code } = await createKsActivity({
					...form,
					anchor_ids,
					cate_commission_list,
					service_rate,
					commission_rate,
					rule_type,
					authority_id,
					preActivityUser,
					preExclusiveActivitySignType,
				});
				if (code !== 0) return;
				this.$message.success('新建招商活动成功');
				this.$emit('refresh');
				this.handleClose();
			});
		}, 1000),
		changeCate(e) {
			if (e === 10) {
				this.$set(this.form, 'cate_commission_list', []);
				this.cascader = [];
			} else {
				this.form.commission_rate = '';
			}
			this.batchCommissionRate = 1;
		},
		//支持类型change
		preExclusiveActivitySignTypeChange(e) {
			this.form.preActivityUser = [];
		},
	},
};
</script>

<style lang="less" scoped>
.drawer {
	background: #fff;
	height: 100%;
	overflow: hidden;
	padding-bottom: 61px;
	.drawer-wrap {
		height: 100%;
		position: relative;
		overflow-y: auto;
		box-sizing: border-box;
		.card {
			padding: 24px 24px 8px;
			& + .card {
				border-top: 12px solid #f8f8f8;
			}
			.label {
				font-size: 16px;
				color: #333;
				line-height: 22px;
				height: 22px;
				border-left: 4px solid @color-primary;
				padding-left: 8px;
				margin-bottom: 20px;
				font-weight: 700;
				&::after {
					content: '*';
					color: #fa2d48;
					font-size: 14px;
					margin-left: 2px;
				}
			}
			&:last-child .label {
				margin-bottom: 8px;
			}
			.handler-table {
				border: 1px solid #eee;
				box-sizing: border-box;
				.header {
					display: flex;
					justify-content: space-between;
					height: 54px;
					line-height: 54px;
					padding-left: 16px;
					padding-right: 120px;
					color: #666;
					font-size: 13px;
					border-bottom: 1px solid #eee;
					background-color: #f6f9ff;
				}
				.footer {
					height: 64px;
					line-height: 64px;
					background-color: #f6f9ff;
					padding-left: 16px;
				}
			}
			.cascader {
				width: 100%;
				::v-deep .el-input__inner::placeholder {
					color: rgba(0, 0, 0, 0);
				}
			}
		}
	}
	.service {
		/deep/ .el-radio {
			margin-right: 6px;
		}
	}
	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}
}
</style>
